module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/store_images/1_28a5732a60bfc5bce3536cd522ea975e.png";